var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-12" },
    [
      _c("div", { staticClass: "flex flex-col md:flex-row" }, [
        _c(
          "div",
          { staticClass: "w-full md:w-1/2 mr-0 md:mr-10" },
          [
            _c("OrganizationCard", {
              attrs: {
                "has-completed": _vm.user.action_flags.has_edited_org_basic,
                organization: _vm.organization,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("hr", {
          staticClass:
            "w-px bg-n-gray border border-n-gray w-full block md:hidden mt-12 mb-12",
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "w-full md:w-1/2 ml-0 md:ml-10" },
          [
            _c("OrganizationReimagine", {
              attrs: {
                "has-completed": _vm.user.action_flags.has_edited_org_reimagine,
                organization: _vm.organization,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("hr", {
        staticClass: "w-px bg-n-gray border border-n-gray w-full mt-12 mb-12",
      }),
      _vm._v(" "),
      _c("OrganizationStory", {
        attrs: {
          "has-completed": _vm.user.action_flags.has_edited_org_story,
          organization: _vm.organization,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }